import { PropsWithChildren } from 'react';

import { Alert } from './Alert';

interface IAlertErrorProps extends PropsWithChildren {
  readonly title: string;
  readonly description?: string;
}

export function AlertError({ title, description, children }: IAlertErrorProps) {
  return (
    <Alert
      icon={
        <img
          src="/images/icon-error.png"
          alt="error"
          className="w-[6.25rem]"
        />
      }
      title={title}
      description={description}
    >
      {children}
    </Alert>
  );
}
